module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAAoUlEQVQ4jb2T2w3DIAxFDyhL9KedJ3M0m2aTSiXZ4vYnSRtkKI+qR0LCBl1dG4OkUVJQP0HS6CQF4MJvWJwkbYHrFBPAYCUbOMz4VjspWgRvucO4hyUlW/eOXInDrKOYnOAu9KgRLnF4/RKfaOmhqUNFD6uIB7v3t+CBZdurcwGsHpiAtdcZ8ATu7v0mSawhTvK3vzxz7s0ne36uESzBLP0Fn7CFe6XXTH4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/master/ico3.png
// module id = 1uxo
// module chunks = 11